exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-fade[data-v-7ba5bd90] {\n  z-index: 7;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0.3;\n  background-color: black;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/Frontend School (Prod)/ui/schools/src/App.vue"],"names":[],"mappings":";AAuEI;EACI,WAAU;EACV,gBAAe;EACf,OAAM;EACN,QAAO;EACP,SAAQ;EACR,UAAS;EACT,aAAY;EACZ,wBAAuB;CAC1B","file":"App.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n    .page-fade {\n        z-index: 7;\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        opacity: 0.3;\n        background-color: black;\n    }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 3dj+
// module chunks = 125